import { withIcon } from "../Icon"

export const IconSwap = withIcon(
  '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.4 6v12m0-12 2.4 2.667M8.4 6 6 8.667M15.6 18V6m0 12 2.4-2.667M15.6 18l-2.4-2.667"/>',
)
